(() => {
    // CUSTOM FILE CREATED TO ADD SIZE OPTIONS - Maximus
    "use strict";
    
    const CARD_SELECTOR = "product-card"; // CARD_SELECTOR = product card element.
    const SWATCH_SELECTOR = "input[type='radio'][name*='Color'][value], input[type='radio'][name*='Colour'][value]"; // SWATCH_SELECTOR = color swatch element.
    const SIZE_SELECTOR = ".size-option"; // SIZE_SELECTOR = size option element.
    const TAG_PREFIX = "hidesku="; // Prefix for product tags that hide SKUs. Example: "hidesku=123456"

    const DEBUG = false; // DEBUG can be set to true to enable console logging for debugging purposes.
    if (DEBUG) console.log("SIZE OPTION DEBUG MODE ENABLED");


    // Create's observer's looking for initial page load and new product cards loading from infinite scroll.
    document.addEventListener("DOMContentLoaded", initCards);
    new MutationObserver(initCards).observe(document.body, {childList: true, subtree: true });

    // Loads data for each product card
    function initCards() {
        document.querySelectorAll(CARD_SELECTOR).forEach((card) => {

            // Checks if card data is already cached.
            if (card.dataset.initalised) {
                return;
            };

            card.dataset.initalised = true;
            

            // Variants = every individual colour / size combination.
            // Options = the names of the options, e.g. "Colour", "Size".
            // Tags = Used to check for hideskus.
            try {
                card._variants = JSON.parse(card.dataset.variants || "[]");
                card._options = JSON.parse(card.dataset.options || "[]");
                card._tags = JSON.parse(card.dataset.tags || "[]");
            } catch (err) {
                console.error("Error in card dataset: ", card, err);
                return;

            }

            let HIDDEN_SKUS = []; // Array of SKUs listed in the product tags. (To be hidden)
            card._tags.forEach((tag) => { if (tag.startsWith(TAG_PREFIX)) {HIDDEN_SKUS.push(tag.replace(TAG_PREFIX, ""));} });
            if (DEBUG && HIDDEN_SKUS.length > 0) console.log("Hidden SKUs: ", HIDDEN_SKUS);

            // OPTION_DATA = Contains relevent SKU's for each colour option.
            const OPTION_DATA = card._variants.reduce((acc, variant) => {
                const colour = variant.option1 ?? "Unknown";
                // ensure the colour bucket exists with both arrays
                acc[colour] ??= { "Public SKUs": [], "Hidden SKUs": [] };

                const bucket = HIDDEN_SKUS.includes(variant.sku) ? "Hidden SKUs" : "Public SKUs";
                acc[colour][bucket].push(variant.sku);

                return acc;
            }, {});
            

            // Listen's for swatch selection changes.
            card.addEventListener("input", (e) => {
                if (e.target.matches(SWATCH_SELECTOR) && e.target.checked) {
                    updateSizes(card, e.target.value, OPTION_DATA);
                }
            });

            
            // Checks if the card has a swatch selected on load.
            const firstColour = card.querySelector(`${SWATCH_SELECTOR}:checked`)?.value
                || card.querySelector(SWATCH_SELECTOR)?.value
                || null;


            updateSizes(card, firstColour, OPTION_DATA);
        });
    };

    // Cleans up strings by removing unwanted characters and trimming whitespace.
    function clean(str = "") {
        return String(str)
        .replace(/\u200B/g, "")   // zero‑width
        .replace(/\u00A0/g, " ")  // nbsp
        .replace(/\u2013/g, "-")  // en‑dash
        .trim();
    }

    // Updates the size options based on the selected colour/print.
  function updateSizes(card, colour, OPTION_DATA) {
    const variants = card._variants;
    const options = card._options; 
    
    // Hide's swatches that have no available SKU's.
    card.querySelectorAll(SWATCH_SELECTOR).forEach((swatch) => {
        if (OPTION_DATA[swatch.value]["Public SKUs"]?.length < 1) {
            swatch.parentElement.classList.toggle("hidden", true);
            swatch.parentElement.setAttribute("aria-disabled", String(true));
            for (const child of swatch.parentElement.children) {
                child.classList.toggle("hidden", true);
                child.setAttribute("aria-disabled", String(true));
            }
            
        }
    });

    const colourIdx = options.findIndex(o => /colou?r/i.test(o));
    const sizeIdx = options.indexOf("Size");

    // If not size options are found, exit early.
    if (sizeIdx < 0) return;
    const wantedColour = clean(colour)
    const sizeLis = card.querySelectorAll(SIZE_SELECTOR);

    sizeLis.forEach((li) => {
        const sizeVal = clean(li.dataset.sizeValue);
        const available = variants.some(v => {
            const matchColour = colourIdx < 0 || clean(v.options[colourIdx]) === wantedColour;
            return matchColour && clean(v.options[sizeIdx]) === sizeVal && v.available;
            });

        li.classList.toggle("unavailable", !available);
        li.setAttribute("aria-disabled", String(!available));
    });
  }
})();